import { Roles } from "../user";

interface ViewableField {
  alwaysVisible: boolean;
  backingFieldName: string;
  customProjectId: number;
  defaultDisplayName: string;
  defaultExcluded: boolean;
  defaultVisible: boolean;
  disableDisplayNameEdit: boolean;
  displayName: string;
  fieldExclude: boolean;
  runConfigurationId: number;
  serializedFieldName: string;
  tableType: TableType;
  visible: boolean;
  isCargoColumn: boolean;
  group: string;
  displayOrder: number;
}

enum TableType {
  Unknown = "Unknown",
  NetworkProviders = "NetworkProviders",
  ProspectProviders = "ProspectProviders",
  MarketProviders = "MarketProviders",
  ProviderTerminations = "ProviderTerminations",
  AggregateAdequacyResults = "AggregateAdequacyResults",
  AccuracyProviders = "AccuracyProviders",
  NextClosestNetworkProviders = "NextClosestNetworkProviders",
  NextClosestProspectProviders = "NextClosestProspectProviders",
  NextClosestMarketProviders = "NextClosestMarketProviders",
  NetNewProviders = "NetNewProviders"
}

const tableTypeRestrictions = new Map<TableType, Roles[]>();
tableTypeRestrictions.set(TableType.ProviderTerminations, [Roles.TERM_PROVIDER_VIEWER, Roles.TERM_PROVIDER_ADMIN]);

export {
  TableType,
  tableTypeRestrictions,
  ViewableField,
};
